import assetScope from './module/assetScope';
import accountCenter from './module/accountCenter';
import advert from './module/advert';
import agreement from './module/agreement';
import brand from './module/brand';
import decorateGlobal from './module/decorateGlobal';
import filter from './module/filter';
import home from './module/home';
import general from './module/general';
import menu from './module/menu';
import material from './module/material';
import product from './module/product';
import order from './module/order';
import member from './module/member';
import print from './module/print';
import deviceAuthorization from './module/deviceAuthorization';
import cashRegister from './module/cashRegister';
import commz from './module/commz';
import integration from './module/integration';
export default {
  ...general, // 通用
  ...assetScope,
  ...accountCenter, // 账号中心
  ...advert, // 广告管理
  ...agreement, // 用户协议
  ...brand, // 品牌
  decorate: { ...brand.decorate, ...decorateGlobal.decorateGlobal }, // 装修及全局配置
  ...filter, // 搜索
  ...home, // 首页
  ...product,
  ...order,
  menu, // 菜单
  material, // 素材
  member, // 会员
  ...print,
  ...integration, // 第三方平台授权
  ...deviceAuthorization,
  ...cashRegister,
  ...commz,
};
